import { render } from "./FpImageUploader.vue?vue&type=template&id=61a69445"
import script from "./FpImageUploader.vue?vue&type=script&lang=js"
export * from "./FpImageUploader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__